import { render, staticRenderFns } from "./AccountBindShop.vue?vue&type=template&id=6f997759&scoped=true"
import script from "./AccountBindShop.vue?vue&type=script&lang=ts"
export * from "./AccountBindShop.vue?vue&type=script&lang=ts"
import style0 from "./AccountBindShop.vue?vue&type=style&index=0&id=6f997759&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f997759",
  null
  
)

export default component.exports